/**
 * Centralized environment configuration.
 * All environment variables are read here with safe fallback defaults.
 * Uses REACT_APP_ prefix (Create React App convention).
 */

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api";

/**
 * The bare server origin (protocol + host + port), e.g. "http://localhost:8080".
 * Use this when a path returned by the API already contains the full /api/... prefix,
 * such as ticket attachment_paths, to avoid doubling the /api segment.
 */
export const BACKEND_ORIGIN = new URL(API_BASE_URL).origin;

export const GOOGLE_OAUTH_URL =
  process.env.REACT_APP_GOOGLE_OAUTH_URL || `${API_BASE_URL}/auth/login/google`;

export const APP_NAME = 'TutoMart';

export const APP_TAGLINE = 'Easy Pricing';
